import cx from 'clsx'
import React, { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'

import s from './styles.module.scss'

import { BUTTON_COLOR, BUTTON_SIZE, BUTTON_WEIGHT } from './button.enum'
import Spinner, { ISpinnerProps } from '../../spinner/Spinner'
import { cn } from '../../../../shadcn/utils'
import { Mixpanel } from '../../../../utils/Mixpanel'

export interface IButtonProps
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  color?: BUTTON_COLOR
  size?: BUTTON_SIZE
  weight?: BUTTON_WEIGHT
  fullWidth?: boolean
  loading?: boolean
  propsSpinner?: ISpinnerProps
  //TODO : make ariaLabel required
  ariaLabel?: string
  notification?: boolean
  buttonPressed?: boolean
  contentClassName?: string
  dataMixpanel?: { name: string; data?: any }
}

const Button = ({
  children,
  className,
  contentClassName,
  size = BUTTON_SIZE.NORMAL,
  color = BUTTON_COLOR.PRIMARY,
  weight = BUTTON_WEIGHT.FILLED,
  fullWidth = false,
  loading,
  onClick,
  disabled = false,
  propsSpinner,
  ariaLabel,
  notification = false,
  buttonPressed,
  dataMixpanel,
  ...rest
}: IButtonProps) => {
  const classes = cx(
    s.button,
    s[size],
    s[color],
    s[weight],
    {
      [s.fullWidth]: fullWidth,
      [s.loading]: loading,
    },
    className,
  )

  return (
    <button
      {...rest}
      className={cn(classes, className)}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={(e) => {
        if (dataMixpanel) {
          Mixpanel.track(dataMixpanel?.name, dataMixpanel?.data)
        }
        onClick && onClick(e)
      }}
    >
      {loading && (
        <span className={s.spinner}>
          <Spinner {...propsSpinner} />
        </span>
      )}
      <div className={cn(s.content, contentClassName)}>{children}</div>
      {notification && !buttonPressed ? (
        <div className={s.notification}>
          <span className={s.notificationText}>1</span>
        </div>
      ) : (
        <></>
      )}
    </button>
  )
}

export default Button
